import { useContext } from 'react';
import type {
  FormattedCompanyInfo,
  FormattedCustomer,
  JobDetails,
} from '../../types';
import Context from '../../Context';
import type { StringIndexedObject } from '~/types';

export interface HeaderPropsHook {
  tradesperson: FormattedCompanyInfo | StringIndexedObject;
  customer: FormattedCustomer | StringIndexedObject;
  details: JobDetails | StringIndexedObject;
  logo: string | null;
}

export default function useHeaderProps(): HeaderPropsHook {
  const { job } = useContext(Context);

  return {
    tradesperson: job?.company || {},
    customer: job?.customer || {},
    details: job?.details || {},
    logo: job?.logo?.logo || null,
  };
}
